import { NgModule } from '@angular/core';
import { AboutTemplateComponent } from './components/about-template/about-template.component';
import { CityFilterService } from './components/template-city-filter/city.filter.service';
import { TemplateCityFilterComponent } from './components/template-city-filter/template-city-filter.component';
import { TemplateCourseCardComponent } from './components/template-course-card/template-course-card.component';
import { TemplateFilterComponent } from './components/template-filter/template-filter.component';
import { TemplateTimeFilterComponent } from './components/template-time-filter/template-time-filter.component';
import { TemplateDetailsComponent } from './pages/template-details/template-details.component';
import { TemplateComponent } from './pages/template/template.component';
import { WrapperComponent } from './pages/wrapper/wrapper.component';
import { TemplateRoutingModule } from './template-routing.module';
import { TemplateStoreModule } from '@modules/template/student/store/template-store.module';
import { DigitalCourseStoreModule } from '@modules/course/digitalcourse/store/digital-course-store.module';
import { SharedModule } from '@shared/shared.module';
import { LocationStoreModule } from '@modules/location/store/location-store.module';
import { TemplateCardComponent } from './components/template-card/template-card.component';
import {
  TemplateHighspeedCoursesComponent
} from './pages/template-highspeed-courses/template-highspeed-courses.component';
import { HighspeedCourseCardComponent } from './components/highspeed-course-card/highspeed-course-card.component';
import { TemplateRequestComponent } from './pages/template-request/template-request.component';
import { TemplateRequestFormComponent } from './components/template-request-form/template-request-form.component';
import { CourseTemplateCardComponent } from './components/course-template-card/course-template-card.component';
import {
  DigitalCoursePreviewCardComponent
} from './components/digital-course-preview-card/digital-course-preview-card.component';
import { TemplateStoreService } from '@modules/template/student/store/services/template-store.service';
import {
  TemplateCoursesResolver,
  TemplateResolver,
  TemplatesResolver
} from '@modules/template/student/store/resolvers';

@NgModule({
    declarations: [
        WrapperComponent,
        TemplateComponent,
        TemplateDetailsComponent,
        TemplateCourseCardComponent,
        AboutTemplateComponent,
        TemplateTimeFilterComponent,
        TemplateCityFilterComponent,
        TemplateFilterComponent,
        TemplateCardComponent,
        TemplateHighspeedCoursesComponent,
        HighspeedCourseCardComponent,
        TemplateRequestComponent,
        TemplateRequestFormComponent,
        CourseTemplateCardComponent,
        DigitalCoursePreviewCardComponent
    ],
    providers: [CityFilterService, TemplateStoreService, TemplateResolver, TemplatesResolver, TemplateCoursesResolver],
    imports: [SharedModule, TemplateStoreModule, DigitalCourseStoreModule, TemplateRoutingModule, LocationStoreModule]
})
export class TemplateModule {
}
